<app-accounting-template
        [title]="title"
        [apiUrl]="apiUrl"
        [tableInfo]="info"
        [type]="'WITH_DRIVER'"
        [rowActionsSettings]="AccountingRowActionsSettings"
        [topActionsSettings]="topActionsSettings"
        [filtersSettings]="filtersSettings"
></app-accounting-template>
